// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__3F_Bp","content":"LoadingAlert_content__1dgfI"};